module.exports = __webpack_public_path__ + "static/media/season-lvp-player.5cac143a.png";